import declare from "dojo/_base/declare";
import New from "csi/table/New";

const NewUnitOfMeasure = declare(New, {

	/**
	 * @override
	 * Show newly created UnitOfMeasure nodes
	 */
	getNewNodes() {
		if (!this.m_response) {
			return this.inherited(arguments);
		}
		return this.m_response.getNodesOfType("UnitOfMeasure");
	},
});

export = NewUnitOfMeasure;